var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-contractor-fields" },
    [
      _c("div", { staticClass: "contractor-info-fields clearfix" }, [
        _c(
          "div",
          {
            staticClass: "contractor-type",
            class: {
              "required-error-highlight":
                _vm.isEditing &&
                _vm.inputRequireHighlight &&
                !_vm.deep(_vm.contractor, "type"),
            },
          },
          [
            _c(
              "label",
              {
                staticClass: "emphasis contractor-title",
                class: { "required-flag": _vm.isEditing },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tenantProjects.contractorType")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isEditing && _vm.canEdit
              ? _c("HKLSelect", {
                  staticClass: "search-company-type",
                  attrs: {
                    value: _vm.contractor.type || undefined,
                    options: _vm.typeHklOptions,
                    showSearch: true,
                    disabled: _vm.isMain || !_vm.isEditing || !_vm.canEdit,
                    placeholder: "",
                  },
                  on: {
                    change: function (val) {
                      return _vm.updateField(["type"], val)
                    },
                  },
                })
              : _c("span", {}, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.contractorTypeView[_vm.contractor.type] ||
                          _vm.$t("emptyValue")
                      ) +
                      "\n      "
                  ),
                ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "contractor-name",
            class: {
              "required-error-highlight":
                _vm.isEditing &&
                _vm.inputRequireHighlight &&
                !_vm.companyName.trim(),
            },
          },
          [
            _c(
              "label",
              {
                staticClass: "emphasis contractor-title",
                class: { "required-flag": _vm.isEditing },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tenancy.companyName")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isEditing && _vm.canEdit
              ? _c("HKLSelect", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "search-company-name",
                  attrs: {
                    disabled:
                      (_vm.isMain && !_vm.isTms) ||
                      !_vm.isEditing ||
                      !_vm.canEdit,
                    value: _vm.companyName || undefined,
                    options: _vm.companyHklOptions,
                    showSearch: true,
                    showArrow: false,
                    singleTaggableInput: true,
                    placeholder: "",
                  },
                  on: {
                    search: _vm.onCompanySearch,
                    input: _vm.onCompanyInput,
                    change: _vm.onCompanyChange,
                  },
                })
              : _c("span", {}, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.companyName || _vm.$t("emptyValue")) +
                      "\n      "
                  ),
                ]),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isMain && _vm.isEditing && _vm.canEdit
          ? _c("div", { staticClass: "icon-remove align-right" }, [
              _c("i", {
                staticClass: "fa fa-times-thin",
                on: {
                  click: function ($event) {
                    return _vm.openDeleteConfirm(_vm.contractorIndex)
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isOther &&
                (_vm.contractor.typeDesc || (_vm.isEditing && _vm.canEdit)),
              expression:
                "isOther && (contractor.typeDesc || (isEditing && canEdit))",
            },
          ],
          staticClass: "contractor-other-type clearfix",
          class: { "edit-box-margin": _vm.isEditing && _vm.canEdit },
        },
        [
          _c("TextField", {
            directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
            attrs: {
              value: _vm.contractor.typeDesc,
              readonly: !_vm.isEditing || !_vm.canEdit,
              placeholder: _vm.$t("tenantProjects.hintContractorDesc"),
            },
            on: {
              updateValue: function (val) {
                return _vm.updateField(["typeDesc"], val.trim())
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableWorkPermitsFeature
        ? _c("div", [
            _c(
              "label",
              { staticClass: "primary-contact-title contractor-title" },
              [_vm._v(_vm._s(_vm.$t("contact.primary")))]
            ),
            _vm._v(" "),
            _vm.isMain || !!_vm.contractorEmail
              ? _c("i", { staticClass: "gray_font" }, [
                  _c("span", [_vm._v(_vm._s(_vm.getHintMsg()))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tenant-contractor-admin" },
              [
                _c("ContractorContact", {
                  attrs: {
                    isEditing: _vm.isEditing && _vm.canEdit,
                    contacts: [_vm.deep(_vm.contractor, "primaryContact")],
                    canInvite: _vm.canEdit && !!_vm.contractorEmail,
                    invite: _vm.invite,
                    updatePath: ["primaryContact"],
                    isPrimary: true,
                    update: _vm.updateContact,
                    inputRequireHighlight: _vm.inputRequireHighlight,
                    isSubFromExternal: _vm.isSubFromExternal,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing || _vm.deep(_vm.contractor, "contacts.length")
        ? [
            _c(
              "label",
              { staticClass: "other-contact-title contractor-title" },
              [_c("span", [_vm._v(_vm._s(_vm.$t("contact.other")))])]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "gray_font" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("contact.othersHint")))]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenant-contractor-contact" },
        [
          _c("ContractorContact", {
            attrs: {
              isEditing:
                _vm.isEditing &&
                (_vm.canEdit || _vm.isCurrentContractorPrimaryContact),
              contacts: _vm.contractor.contacts,
              invite: _vm.invite,
              updatePath: ["contacts"],
              isPrimary: false,
              update: _vm.updateContact,
              toggleContact: _vm.toggleContact,
              inputRequireHighlight: _vm.inputRequireHighlight,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canEditDocs && _vm.canViewDocs
        ? _c("HkldDropzone", { attrs: { sourceId: _vm.contractor.id || "" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.canViewDocs
        ? _c("EditAttachments", {
            attrs: {
              sourceId: _vm.deep(_vm.contractor, "id") || "",
              canDelete: _vm.canEditDocs,
              canEdit: _vm.canEditDocs,
              showEmptyMsg: true,
              emptyMsg: _vm.$t("tenantProjects.contractorEmptyDocHint"),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }